"use client";

import { LATENCY, LATENCY_COLORS } from "@/config/constants";

interface LatencyBadgeProps {
  ms: number;
  delta?: number;
}

export default function LatencyBadge({ ms, delta }: LatencyBadgeProps) {
  let color: string = LATENCY_COLORS.excellent;
  if (ms > LATENCY.SLOW) color = LATENCY_COLORS.poor;
  else if (ms > LATENCY.MODERATE) color = LATENCY_COLORS.moderate;
  else if (ms > LATENCY.GOOD) color = LATENCY_COLORS.good;

  return (
    <span className="font-[family-name:var(--font-geist-mono)] text-[11px]" style={{ color }}>
      {Math.round(ms)}ms
      {delta !== undefined && delta > 0 && (
        <span className="text-[#71717A] ml-1">(+{Math.round(delta)}ms)</span>
      )}
    </span>
  );
}
